import { Link } from "react-router-dom";
import { GetCompras } from "../../actions/Compra.jsx";
import { GotoLogin } from "../../actions/renovarLog.jsx";

import style from "../../styles/grid.module.css";
import axios from "axios";
import { Pencil, SquareX, CirclePlus } from "lucide-react";

const AbmCompras = () => {
   const url = process.env.REACT_APP_URL_DIR + "sqlraw/comprai/";
   const compras = GetCompras();
   const filtroTipo = 2;
   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };

   if (compras?.message === "Token inválido") {
      return <GotoLogin />;
   }

   const handleRemove = async (id) => {
      let text =
         "Se va a eliminar la compra selecionada!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         const response = await axios.delete(url + id);
         console.log("response: ", response);
         window.location.href = "/CompraIns";
      }
   };
   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });
   console.log("compras: ", compras);
   return (
      <>
         <div className={style.tableCli}>
            <div>
               <div>
                  <div className={style.gridTitle}>
                     <h2>Compras Insumos Piercing</h2>
                  </div>
               </div>
            </div>
            <div>
               <div>
                  <Link
                     to={"/formCompraIns"}
                     className="dLink"
                     title="Alta Compra"
                     state={{
                        tabla: "compra",
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        descripcion: "",
                        dolar: 0,
                        cod_status: 1,
                        stock: 0,
                     }}
                  >
                     <CirclePlus className="lucidePlus" />
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
         </div>
         <div className={style.divtable}>
            <table className={style.gridTable}>
               <thead>
                  <tr>
                     <th className={style.style_titulos}>Fecha</th>
                     <th>Descripcion</th>
                     <th>Total</th>
                     <th>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {compras &&
                     compras?.map((insu) => {
                        if (parseInt(filtroTipo) === parseInt(insu.tipo)) {
                           return (
                              <tr
                                 key={insu.id}
                                 className={
                                    parseInt(insu.cod_status) === 2
                                       ? style.trdatosRed
                                       : style.trdatos
                                 }
                              >
                                 <td className={style.style_code}>
                                    {formatDate(insu.fecha)}
                                 </td>
                                 <td className={style.style_td}>
                                    {insu.titulo}
                                 </td>
                                 <td className={style.precio}>  $&nbsp;{numberFormat.format(insu.total)}</td>
                                 <td className={style.aligncenter}>
                                    <Link
                                       to={"/formCompraIns"}
                                       className="dLink"
                                       state={{
                                          tabla: "compra",
                                          id_primary: insu.id_primary,
                                          id: insu.id,
                                          companyId: insu.companyId,
                                          cod_status: insu.cod_status,
                                          productos: insu.productos,
                                          total: insu.total,
                                          insumos: insu.insumos,
                                          compra: insu.insumos,
                                          titulo: insu.titulo,
                                       }}
                                    >
                                      <Pencil className="lucideIcon" />
                                       {/* <FcAcceptDatabase style={estilo} /> */}
                                    </Link>
                                    &nbsp;&nbsp;
                                    <span
                                       className="lucideIconDel"
                                       title="Eliminar compra"
                                    >
                                       <SquareX
                                          className="lucideIconDel"
                                          onClick={() => handleRemove(insu.id_primary)}
                                       />
                                    </span>
                                 </td>
                              </tr>
                           );
                        } else {
                           return null;
                        }
                     })}
               </tbody>
            </table>
         </div>
      </>
   );
};

export default AbmCompras;
